
import React from 'react';

export const ExpertiseSection: React.FC = () => {
  const expertiseAreas = [
    {
      category: 'Corporate Governance',
      items: [
        'Board Structure & Composition',
        'Regulatory Compliance',
        'Risk Management Frameworks',
        'Executive Compensation',
        'Shareholder Relations',
        'ESG Implementation'
      ]
    },
    {
      category: 'Client Acquisition',
      items: [
        'Market Research & Analysis',
        'Lead Generation Systems',
        'Sales Funnel Optimization',
        'Customer Segmentation',
        'Digital Marketing Strategy',
        'Conversion Rate Optimization'
      ]
    },
    {
      category: 'Strategic Partnerships',
      items: [
        'Partnership Strategy Development',
        'Due Diligence Processes',
        'Contract Negotiation',
        'Joint Venture Structuring',
        'Alliance Management',
        'Performance Monitoring'
      ]
    },
    {
      category: 'Revenue Growth',
      items: [
        'Business Model Innovation',
        'Pricing Strategy Optimization',
        'Market Expansion Planning',
        'Operational Efficiency',
        'Technology Integration',
        'Performance Analytics'
      ]
    }
  ];

  return (
    <section id="expertise" className="py-20 bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold mb-4">
            Deep Expertise Across Critical Business Functions
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            Our comprehensive expertise spans the essential areas that drive business success, ensuring your organization has the strategic advantage needed to thrive in today's competitive landscape.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {expertiseAreas.map((area, index) => (
            <div key={index} className="bg-gray-800 rounded-xl p-6 hover:bg-gray-700 transition-colors">
              <h3 className="text-xl font-bold mb-6 text-blue-400">{area.category}</h3>
              <ul className="space-y-3">
                {area.items.map((item, itemIndex) => (
                  <li key={itemIndex} className="flex items-start">
                    <i className="ri-arrow-right-s-line text-blue-400 mt-1 mr-2 flex-shrink-0"></i>
                    <span className="text-gray-300">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        
        <div className="mt-16 bg-blue-600 rounded-2xl p-8 text-center">
          <h3 className="text-2xl font-bold mb-4">Ready to Accelerate Your Growth?</h3>
          <p className="text-blue-100 mb-6 max-w-2xl mx-auto">
            Let our expertise in corporate governance, client acquisition, and strategic partnerships drive your organization's success. Contact us today to discuss your specific needs.
          </p>
          <button 
            onClick={() => document.querySelector('#vapi-widget-floating-button')?.click()}
            className="bg-white text-blue-600 px-8 py-3 rounded-lg font-semibold hover:bg-gray-100 transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-phone-line mr-2"></i>
            Schedule a Consultation
          </button>
        </div>
      </div>
    </section>
  );
};
